const gridCategoryMapping = (data) => {

  const mappedData = {};

  mappedData.title = data.field_component_title[0]?.value || '';

  mappedData.items = data.field_grid_items.map((item) => {

    return {
      id: item.id[0]?.value,
      frontImageSrc: item.field_desktop_img[0]?.url || '',
      frontImageAlt: item.field_desktop_img[0]?.alt || '',
      backLayerSrc: item.field_back_effect_img[0]?.url || '',
      backLayerAlt: item.field_back_effect_img[0]?.alt || '',
      middleLayerSrc: item.field_effect_img[0]?.url || '',
      middleLayerAlt: item.field_effect_img[0]?.alt || '',
      description: item.field_component_body[0]?.value || '',
      cta: {
        title: item.field_cta[0]?.title || '',
        alt: item.field_cta[0]?.options?.attributes?.['aria-label'] || '',
        href: item.field_cta[0]?.url || item.field_cta[0]?.uri || '',
        ariaLabel: item.field_cta[0]?.options?.attributes?.['aria-label'] || '',
      }
    };
  });

  return mappedData;
};


export default gridCategoryMapping;
